"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TeaserType;
(function (TeaserType) {
    TeaserType["One"] = "teaser-slider-one";
    TeaserType["Two"] = "teaser-slider-two";
    TeaserType["Three"] = "teaser-slider-three";
    TeaserType["Four"] = "teaser-slider-four";
    TeaserType["Five"] = "teaser-slider-five";
    TeaserType["Six"] = "teaser-slider-six";
    TeaserType["Quote"] = "quotes-slider";
    TeaserType["Gallery"] = "gallery-slider";
    TeaserType["NoClick"] = "teaser-slider-noclick";
    TeaserType["Overlay"] = "teaser-slider-overlay";
})(TeaserType || (TeaserType = {}));
var SLIDER_SPACING = 21;
var SLIDER_ANIMATION_MS = 400;
var INIT_DELAY_MS = 200;
var MIN_WIDTH = 90;
var MIN_ITEM_WIDTH = 180;
var MIN_ITEM_WIDTH_TWO = 320;
var MIN_ITEM_WIDTH_THREE = 280;
var MIN_ITEM_WIDTH_THREE_ALT = 300;
var SWIPE_DISTANCE = 50;
var MIN_SWIPE_MOVE = 5;
var NAVIGATION_THRESHOLD = 5;
var TeaserSlider = /** @class */ (function () {
    function TeaserSlider(element) {
        this.marginLeft = 0;
        this.swipeDistance = SWIPE_DISTANCE;
        this.swipeActionDone = false;
        this.eventsBound = false;
        this.isDialogOpen = false;
        this.element = element;
        this.assignElements();
        this.setImageData();
        this.init(null);
        this.initEventListeners();
    }
    TeaserSlider.prototype.getElement = function () {
        return this.element;
    };
    TeaserSlider.prototype.getListElement = function () {
        return this.list;
    };
    TeaserSlider.prototype.doBackward = function () {
        this.swipeActionDone = true;
        this.moveBy(this.itemWidth + SLIDER_SPACING, "backward");
        if (this.isDialogOpen && !this.isLinkVisible("backward")) {
            this.focusSiblingElement(this.backwardLink, "next");
        }
    };
    TeaserSlider.prototype.doForward = function () {
        this.swipeActionDone = true;
        if (!this.isLinkVisible("forward"))
            return;
        this.moveBy(this.itemWidth + SLIDER_SPACING, "forward");
        if (this.isDialogOpen && !this.isLinkVisible("forward")) {
            this.focusSiblingElement(this.forwardLink, "next");
        }
    };
    TeaserSlider.prototype.doMove = function (distance) {
        this.swipeActionDone = true;
        this.setSliderTransform(this.marginLeft - distance);
    };
    TeaserSlider.prototype.openDialog = function (dataIndex) {
        if (dataIndex === void 0) { dataIndex = 0; }
        if (this.teaserTypeEquals(TeaserType.One))
            return;
        this.prepareDialogView();
        this.toggleDialogMode(true);
        this.focusOnCloseLink();
        this.isDialogOpen = true;
        this.init(dataIndex);
    };
    TeaserSlider.prototype.closeDialog = function () {
        if (!this.teaserTypeEquals(TeaserType.One))
            return;
        this.restoreDefaultView();
        this.toggleDialogMode(false);
        this.restoreLastFocus();
        this.isDialogOpen = false;
        this.init(null);
    };
    TeaserSlider.prototype.init = function (showItem) {
        var _this = this;
        setTimeout(function () {
            _this.calculateItemWidth();
            _this.teaserItems.forEach(function (item) {
                item.style.width = _this.itemWidth + "px";
                item.style.padding = "";
            });
            _this.listWidth = _this.list.scrollWidth;
            _this.updateNavigation();
            if (_this.teaserTypeEquals(TeaserType.Gallery)) {
                _this.initGalleryEvents();
                _this.initGalleryOverlay(showItem);
            }
        }, INIT_DELAY_MS);
    };
    TeaserSlider.prototype.assignElements = function () {
        this.panel = this.element.querySelector(".teaser-slider-panel");
        this.wrapper = this.element.querySelector(".teaser-slider-list-wrapper");
        this.list = this.element.querySelector(".teaser-slider-list");
        this.closeLink = this.element.querySelector(".close-link");
        this.backwardLink = this.element.querySelector(".backward-link");
        this.forwardLink = this.element.querySelector(".forward-link");
        this.teaserItems = this.list.querySelectorAll("li");
        this.images = Array.from(this.list.getElementsByTagName("img"));
    };
    TeaserSlider.prototype.setImageData = function () {
        var _this = this;
        this.images.forEach(function (img, index) {
            var _a;
            img.addEventListener("mousedown", function (e) { return e.preventDefault(); });
            img.dataset.index = index.toString();
            (_a = img.parentElement) === null || _a === void 0 ? void 0 : _a.setAttribute("data-index", index.toString());
            if (img.dataset.title) {
                _this.appendSpan(img, "img-title", img.dataset.title);
            }
            if (img.dataset.copyright) {
                _this.appendSpan(img, "img-copyright", img.dataset.copyright);
            }
        });
    };
    TeaserSlider.prototype.initEventListeners = function () {
        var _this = this;
        window.addEventListener('resize', function () { return _this.handleResize(); });
        document.addEventListener("keyup", function (e) {
            if (!_this.teaserTypeEquals(TeaserType.One))
                return;
            if (e.key === "ArrowRight")
                _this.doForward();
            if (e.key === "ArrowLeft")
                _this.doBackward();
            if (e.key === "Escape")
                _this.closeDialog();
        });
        this.list.addEventListener("click", function (e) { return _this.handleListClick(e); });
        this.list.addEventListener("transitionend", function () { return _this.resetTransition(); });
        if (this.teaserItems.length > 1) {
            this.initSwipeEvents();
        }
        this.backwardLink.addEventListener('click', function (e) {
            _this.preventDefaults(e);
            _this.doBackward();
        });
        this.forwardLink.addEventListener('click', function (e) {
            _this.preventDefaults(e);
            _this.doForward();
        });
    };
    TeaserSlider.prototype.initGalleryEvents = function () {
        var _this = this;
        if (this.eventsBound)
            return;
        if (this.closeLink) {
            this.closeLink.addEventListener("click", function (e) { _this.preventDefaults(e); _this.closeDialog(); });
            this.closeLink.addEventListener("keydown", function (e) { return _this.handleControlKeydown(e, _this.closeLink); });
        }
        [this.backwardLink, this.forwardLink].forEach(function (link) {
            link.addEventListener("keydown", function (e) { return _this.handleControlKeydown(e, link); });
        });
        this.eventsBound = true;
    };
    TeaserSlider.prototype.initGalleryOverlay = function (showItem) {
        if (this.teaserTypeEquals(TeaserType.One)) {
            this.wrapper.style.marginTop = this.wrapper.offsetHeight / -2 + "px";
            if (showItem && showItem > 0) {
                this.marginLeft += ((this.itemWidth + SLIDER_SPACING) * -1) * showItem;
                this.resetTransition();
                this.list.style.transform = "translate(" + this.marginLeft + "px, 0)";
                this.setLinkVisibility("forward", this.teaserPanelWidth < this.listWidth + this.marginLeft - NAVIGATION_THRESHOLD);
                this.setLinkVisibility("backward", this.marginLeft !== 0);
            }
        }
    };
    TeaserSlider.prototype.initSwipeEvents = function () {
        var _this = this;
        var startX = 0;
        var isSwiping = false;
        this.list.addEventListener("touchstart", function (e) {
            startX = e.changedTouches[0].clientX;
        });
        this.list.addEventListener("touchmove", function (e) {
            var deltaX = startX - e.changedTouches[0].clientX;
            _this.handleSwipeMove(deltaX, e);
        });
        this.list.addEventListener("touchend", function (e) {
            var endX = e.changedTouches[0].clientX;
            _this.handleSwipeEnd(startX, endX, e);
        });
        this.list.addEventListener("mousedown", function (e) {
            if (e.button == 0) {
                startX = e.clientX;
                isSwiping = true;
            }
        });
        window.addEventListener("mousemove", function (e) {
            if (isSwiping) {
                var deltaX = startX - e.clientX;
                _this.handleSwipeMove(deltaX, e);
            }
        });
        window.addEventListener("mouseup", function (e) {
            if (isSwiping) {
                var endX = e.clientX;
                isSwiping = false;
                _this.handleSwipeEnd(startX, endX, e);
            }
        });
    };
    TeaserSlider.prototype.handleResize = function () {
        this.resetSliderPosition();
        this.init(null);
    };
    TeaserSlider.prototype.handleListClick = function (e) {
        if (this.swipeActionDone) {
            this.preventDefaults(e);
        }
        else if (this.teaserTypeEquals(TeaserType.Gallery) && !this.teaserTypeEquals(TeaserType.NoClick)) {
            this.preventDefaults(e);
            var currentTarget = e.target;
            var currentTargetIndex = parseInt(currentTarget.dataset.index || "0");
            this.openDialog(currentTargetIndex);
        }
        this.swipeActionDone = false;
    };
    TeaserSlider.prototype.handleSwipeMove = function (deltaX, e) {
        if (Math.abs(deltaX) < MIN_SWIPE_MOVE)
            return;
        this.preventDefaults(e);
        this.doMove(deltaX);
    };
    TeaserSlider.prototype.handleSwipeEnd = function (startX, endX, evt) {
        var deltaX = startX - endX;
        if (this.isLinkVisible("forward") && deltaX > this.swipeDistance) {
            this.preventDefaults(evt);
            this.doForward();
        }
        else if (deltaX < -this.swipeDistance) {
            this.preventDefaults(evt);
            this.doBackward();
        }
        else {
            this.setSliderTransform();
        }
    };
    TeaserSlider.prototype.handleControlKeydown = function (e, current) {
        if (!this.isDialogOpen)
            return;
        this.preventDefaults(e);
        switch (e.key) {
            case "Tab":
                e.shiftKey
                    ? this.focusSiblingElement(current, "prev")
                    : this.focusSiblingElement(current, "next");
                break;
            case "Enter":
            case "Space":
                if (current === this.backwardLink)
                    this.doBackward();
                if (current === this.forwardLink)
                    this.doForward();
                if (current === this.closeLink)
                    this.closeDialog();
                break;
        }
    };
    TeaserSlider.prototype.calculateItemWidth = function () {
        this.teaserPanelWidth = this.panel.clientWidth;
        if (this.teaserTypeEquals(TeaserType.One)) {
            this.itemWidth = Math.round(this.teaserPanelWidth);
        }
        else if (this.teaserTypeEquals(TeaserType.Two)) {
            this.itemWidth = Math.max(Math.round((this.teaserPanelWidth - SLIDER_SPACING) / 2), MIN_ITEM_WIDTH_TWO);
        }
        else if (this.teaserTypeEquals(TeaserType.Six)) {
            this.itemWidth = Math.max(Math.round((this.teaserPanelWidth - SLIDER_SPACING) / 6), MIN_ITEM_WIDTH);
        }
        else {
            this.itemWidth = Math.round((this.teaserPanelWidth - SLIDER_SPACING * 2) / 3);
            if (this.itemWidth < MIN_WIDTH) {
                this.itemWidth = MIN_ITEM_WIDTH_THREE;
            }
            else if (this.itemWidth < 300) {
                this.itemWidth = MIN_ITEM_WIDTH_THREE_ALT;
            }
        }
    };
    TeaserSlider.prototype.updateNavigation = function () {
        var canScrollLeft = this.marginLeft < 0;
        var canScrollRight = this.teaserPanelWidth < (this.listWidth + this.marginLeft - NAVIGATION_THRESHOLD);
        this.setLinkVisibility("backward", canScrollLeft);
        this.setLinkVisibility("forward", canScrollRight);
    };
    TeaserSlider.prototype.setSliderTransform = function (x, duration) {
        if (x === void 0) { x = this.marginLeft; }
        if (duration === void 0) { duration = SLIDER_ANIMATION_MS; }
        this.list.style.transition = "transform " + duration + "ms";
        this.list.style.transform = "translate(" + x + "px, 0)";
    };
    TeaserSlider.prototype.setLinkVisibility = function (direction, visible) {
        var link = direction === "forward" ? this.forwardLink : this.backwardLink;
        if (!link)
            return;
        link.style.display = visible ? 'block' : 'none';
    };
    TeaserSlider.prototype.isLinkVisible = function (direction) {
        var _a;
        var link = direction === "forward" ? this.forwardLink : this.backwardLink;
        return ((_a = link) === null || _a === void 0 ? void 0 : _a.style.display) === "block";
    };
    TeaserSlider.prototype.moveBy = function (distance, direction) {
        var newMargin = this.marginLeft + (direction === "forward" ? -distance : distance);
        var maxScroll = this.listWidth - this.teaserPanelWidth;
        this.marginLeft = Math.max(-maxScroll, Math.min(0, newMargin));
        this.setSliderTransform();
        this.updateNavigation();
    };
    TeaserSlider.prototype.swapImages = function (size) {
        this.images.forEach(function (img) {
            var srcAttr = size === "big" ? "data-big-src" : "data-small-src";
            var setAttr = size === "big" ? "data-small-src" : "data-big-src";
            var src = img.getAttribute(srcAttr);
            if (src) {
                img.setAttribute(setAttr, img.src);
                img.src = src;
            }
            var srcsetAttr = size === "big" ? "data-big-srcset" : "data-small-srcset";
            var setSrcsetAttr = size === "big" ? "data-small-srcset" : "data-big-srcset";
            var srcset = img.getAttribute(srcsetAttr);
            if (srcset) {
                img.setAttribute(setSrcsetAttr, img.srcset);
                img.srcset = srcset;
            }
        });
    };
    TeaserSlider.prototype.resetSliderPosition = function () {
        this.marginLeft = 0;
        this.list.style.transform = "translate(0,0)";
    };
    TeaserSlider.prototype.resetTransition = function () {
        this.list.style.transition = "";
    };
    TeaserSlider.prototype.toggleDialogMode = function (isOpen) {
        var heading = this.element.querySelector('h1, h2, h3, h4, h5, h6');
        var ariaLabelId = 'slider-overlay-label';
        this.element.classList.toggle(TeaserType.Overlay, isOpen);
        this.element.classList.toggle(TeaserType.One, isOpen);
        if (isOpen) {
            this.element.setAttribute('role', 'dialog');
            this.element.setAttribute('aria-modal', 'true');
            if (heading) {
                heading.id = ariaLabelId;
                this.element.setAttribute('aria-labelledby', ariaLabelId);
            }
        }
        else {
            this.element.removeAttribute('role');
            this.element.removeAttribute('aria-modal');
            if (heading) {
                heading.removeAttribute("id");
                this.element.removeAttribute('aria-labelledby');
            }
        }
    };
    TeaserSlider.prototype.prepareDialogView = function () {
        this.swapImages("big");
        this.resetSliderPosition();
        this.addTabIndexToLinks(-1);
    };
    TeaserSlider.prototype.restoreDefaultView = function () {
        this.swapImages("small");
        this.resetSliderPosition();
        this.addTabIndexToLinks(0);
        this.wrapper.style.marginTop = "0";
    };
    TeaserSlider.prototype.focusOnCloseLink = function () {
        this.lastDocumentElement = document.activeElement;
        this.closeLink.focus();
    };
    TeaserSlider.prototype.restoreLastFocus = function () {
        if (this.lastDocumentElement instanceof HTMLElement) {
            this.lastDocumentElement.focus();
        }
    };
    TeaserSlider.prototype.getFocusableElements = function () {
        return this.element.querySelectorAll('.close-link, .backward-link, .forward-link');
    };
    TeaserSlider.prototype.focusSiblingElement = function (current, direction) {
        var _a;
        var elements = Array.from(this.getFocusableElements()).filter(function (el) { return el.style.display !== "none"; });
        var idx = elements.indexOf(current);
        var nextIdx = (idx + (direction === "next" ? 1 : -1) + elements.length) % elements.length;
        (_a = elements[nextIdx]) === null || _a === void 0 ? void 0 : _a.focus();
    };
    TeaserSlider.prototype.addTabIndexToLinks = function (tabIndex) {
        if (tabIndex === void 0) { tabIndex = 0; }
        for (var i = 0; i < this.teaserItems.length; i++) {
            this.teaserItems[i].querySelector('a').tabIndex = tabIndex;
        }
    };
    TeaserSlider.prototype.teaserTypeEquals = function (type) {
        return this.element.classList.contains(type);
    };
    TeaserSlider.prototype.preventDefaults = function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
    };
    TeaserSlider.prototype.appendSpan = function (img, className, text) {
        var _a;
        var span = document.createElement("span");
        span.classList.add(className);
        span.innerText = text;
        (_a = img.parentElement) === null || _a === void 0 ? void 0 : _a.appendChild(span);
    };
    return TeaserSlider;
}());
exports.TeaserSlider = TeaserSlider;
